import React from 'react';

export default function Card({ title, glow = false, children, className = '', headerRight, style }) {
  const cls = ['card', glow ? 'card-glow' : '', className].filter(Boolean).join(' ');
  return (
    <div className={cls} style={style}>
      {(title || headerRight) && (
        <div className="flex justify-between items-center mb-2" style={{ marginBottom: 14 }}>
          {title && <div className="card-title" style={{ marginBottom: 0 }}>{title}</div>}
          {headerRight}
        </div>
      )}
      {children}
    </div>
  );
}
